import React from 'react';
import styles from './IconButtons.module.css';
import classNames from 'classnames';
import { ReactComponent as PrintIcon } from '../../../assets/images/printer.svg';

const PrintButton = ({ text = null, id, onClick, isDisabled = false }) => (
    <button
        className={classNames('btn-secondary', styles.iconBtn)}
        id={id && id}
        onClick={onClick}
        disabled={isDisabled}
    >
        <PrintIcon
            alt='print'
            id={id && id}
        />
        {text || 'Print'}
    </button>
);

export default PrintButton;
